class historyElement extends HTMLElement{
    constructor(){
        super()
        this.navigation = this.querySelector(".history-navigation-container")
        this.navigationInputs = this.navigation.querySelectorAll(".navigation-link")
        this.navigationInputs.forEach((input) =>{
            input.addEventListener("click", this.scrollToNav.bind(this))
        })
        this.content = this.querySelectorAll(".history-block-wrapper")
        window.addEventListener('scroll', this.markActiveElements.bind(this));
        this.markActiveElements();
        



    }

    // Funktion zur Überprüfung, ob ein Element in der Mitte des sichtbaren Bereichs des Fensters ist
    isInViewport(element) {
    const rect = element.getBoundingClientRect();
    const windowHeight = window.innerHeight || document.documentElement.clientHeight;
  
    return (
      rect.top <= windowHeight / 2 &&
      rect.bottom >= windowHeight / 2
    );
  }
  
  // Funktion zum Markieren der history-block-wrapper-Elemente als aktiv
    markActiveElements() {
    const historyBlockWrappers = this.querySelectorAll('.history-block-wrapper');
  
    historyBlockWrappers.forEach(element => {
        let year = element.dataset.year
        let navElement = this.querySelector(`#nav--${year}`)
        let historyOverflowContainer = this.querySelector('.history-overflow-container');
      if (this.isInViewport(element)) {
        element.classList.add('active');
        this.activeYear = year
        if(!navElement.classList.contains("active")){
          historyOverflowContainer.scrollLeft = navElement.offsetLeft - historyOverflowContainer.offsetLeft;
        }
        navElement.classList.add("active")
      } else{
        element.classList.remove('active');
        if(this.activeYear != year)
        navElement.classList.remove("active")
        
      }
    });
  }
  
    scrollToNav(event){
        const windowHeight = window.innerHeight || document.documentElement.clientHeight;
        event.preventDefault();
        // this.querySelector(".year.active").classList.remove("active")
        let yearElement = event.target.closest(".year")
        let blockId = yearElement.dataset.block
        let contentElement = this.querySelector(`#history--${blockId}`)
        // this.querySelector(".history-block-wrapper.active").classList.remove("active")
        // contentElement.classList.add("active")
        const targetId = event.target.getAttribute('href'); // Extrahiert die Ziel-ID aus dem href-Attribut
        const targetElement = this.querySelector(targetId);
        if (targetElement && window.innerWidth > 750) {
            const yOffset = - windowHeight / 2 + contentElement.clientHeight / 2; // Sie können hier den gewünschten Versatz einstellen
            const y = targetElement.getBoundingClientRect().top + window.pageYOffset + yOffset;
            window.scrollTo({ top: y, behavior: 'smooth' }); // Scrollt zur Zielposition
          }
        else if(targetElement){
            let y = targetElement.getBoundingClientRect().top + window.pageYOffset - this.navigation.clientHeight
            if(y < window.pageYOffset){
                console.log("scroll up")
                y = y - 70
            }
            window.scrollTo({ top: y, behavior: 'smooth' })
        }
        
    }

  
}
customElements.define("history-element",historyElement)




